import React, { useState } from "react";

import ZoomQuotationForm from "./ZoomQuotationForm";
import useStore from "../../store/information";

const ZoomQuotationMain = ({courseID,courseName }) => {
    const { totalInfo } = useStore();
    const cleanContent = (html) => {
    if (!html) return "";

    return html
      .split(/<br\s*\/?>|<\/?p>/) 
      .filter(item => item.trim() !== "" && item !== "&nbsp;")
      .map(text => `<p>${text}</p>`)
      .join("");
  };

  return (
    <>
      <div
        id="react-contact"
        className="react-contact-page pt---100 form-container"
      >
        <div className="">
      
          <div className="row d-flex pb---96" style={{width:"75%",margin:"auto"}}>
          <div dangerouslySetInnerHTML={{ __html: cleanContent(totalInfo?.info) }}  className=" level-test-description"></div>
        <ZoomQuotationForm courseID={courseID} courseName={courseName}/>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default ZoomQuotationMain;
